// Utility functions for generating country links based on referrer URL

/**
 * Get the base URL from document.referrer or fallback to default
 * @returns {string} Base URL without trailing slash
 */
export function getBaseUrl() {
  const referrer = document.referrer;
  const fallbackUrl = 'https://dimovtax.com';
  
  if (!referrer) {
    return fallbackUrl;
  }
  
  try {
    const url = new URL(referrer);
    // Return the origin (protocol + hostname + port)
    return url.origin;
  } catch (error) {
    console.warn('Invalid referrer URL:', referrer);
    return fallbackUrl;
  }
}

/**
 * Convert country name to URL-safe format
 * @param {string} countryName - The country name to convert
 * @returns {string} URL-safe country name
 */
export function countryNameToUrlSafe(countryName) {
  return countryName
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with hyphens
    .replace(/[^a-z0-9-]/g, '')     // Remove special characters except hyphens
    .replace(/-+/g, '-')            // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, '');         // Remove leading/trailing hyphens
}

/**
 * Generate country guide URL
 * @param {string} countryName - The country name
 * @returns {string} Complete URL for the country guide
 */
export function generateCountryUrl(countryName) {
  const baseUrl = getBaseUrl();
  const urlSafeName = countryNameToUrlSafe(countryName);
  return `${baseUrl}/country-guides/${urlSafeName}`;
}
